<template>
	<div class="">

	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue